import React from 'react';
import { COLORS, SPACING, STYLES } from '../../designSystem';
import Card from './Card';

export default function FormCard({ title, children, footer, fullWidth = false }) {
  return (
    <Card fullWidth={fullWidth}>
      {title && (
        <div style={STYLES.cardHeader}>
          <h2 style={STYLES.cardTitle}>{title}</h2>
        </div>
      )}
      <div>{children}</div>
      {footer && (
        <div
          style={{
            marginTop: SPACING.LG,
            paddingTop: SPACING.LG,
            borderTop: `1px solid ${COLORS.BORDER_LIGHT}`,
          }}
        >
          {footer}
        </div>
      )}
    </Card>
  );
}
